<template>
<div class='b-event-month-card__wrapper'>
    <EventMonthCard
        v-for='(event, index) in events'
        :key='index'
        :event='event'
        @click='$emit("openEvent", event)'>
    </EventMonthCard>
</div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { EventMonthCard } from '@/components/simple/EventMonthCard';
import { CalendarInstanceType } from '@/types/Events/CalendarInstanceType';

@Component({
    emits: ['openEvent'],
    components: {
        EventMonthCard,
    },
})
export default class EventsList extends Vue {
    @Prop({ type: Array, required: true }) readonly events!: Array<CalendarInstanceType>;
}

</script>

<style lang='sass'>
.b-event-month-card__wrapper
    width: 100%
    margin-top: 8px
    padding: 6px 4px
    height: calc(100% - 16px)
    overflow: auto
</style>
